import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { CurrencyInterface } from '../../../interfaces/interfaces';

export const getCurrencyColumns = (
  setCurrencyToDelete: (currency: CurrencyInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setCurrencyToUpdate: (currency: CurrencyInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'code', headerName: 'Code', width: 100 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'symbol', headerName: 'Symbol', width: 100 },
  { field: 'rate', headerName: 'Rate', width: 120, type: 'number' },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setCurrencyToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setCurrencyToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];